export default __webpack_public_path__ + "static/eye_wash_w.eb53a15d7ae74101d1c78aa9faf60804.svg";